import { OFFICER_COL_WIDE, OFFICER_TABLE_COLS } from './coverage-table-grid'

const TH = 'text-[10.5px] font-bold uppercase tracking-[.06em] text-gis-heading'

/** Column header for the By-officer table (By officer view only). */
export function CoverageOfficersHeaderRow() {
  return (
    <div className={`${OFFICER_TABLE_COLS} border-b border-gis-line-2 px-3 py-[7px]`}>
      <span className={TH}>Officer</span>
      <span className={`${TH} text-right`}>Sites</span>
      <span className={`${TH} ${OFFICER_COL_WIDE}`}>Progress</span>
      <span className={`${TH} text-right`}>Done</span>
    </div>
  )
}
